angular.module("app").controller("CategoriesListPageController", [
    '$scope',
    'preloadedData',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoCategoryService',
    'errorHandler',
    '$state',
    '$stateParams',
    function ($scope, preloadedData, pageStatuses, pagination, $timeout, casinoCategoryService, errorHandler, $state, $stateParams) {
        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;
        $scope.categories = angular.copy(preloadedData.categories);
        $scope.parentId = $stateParams.itemId;
        $scope.filterOptions = {
            status: pageStatuses[0]
        };

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage && (requestData.current_page = 1);
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            }, 300);
        }, preloadedData.total_count);


        $scope.getItemChildes = function (category) {
            $state.go("main.categories.categoryItems", {itemId: category.id}, {reload: false})
        };


        $scope.editCategory = function (category) {
            $state.go($scope.parentId ? "main.categories.editItem" : "main.categories.edit", {categoryId: category.id, itemId: $scope.parentId})
        };

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        function getFiltersValues() {
            return {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status
            }
        }

        function updateList (requestOptions) {
            casinoCategoryService.get(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.categories = angular.copy(response.categories)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
    }
]);